// Shared field components for admin editors
export function Field({ label, value, onChange, type = "text", testid, placeholder }) {
  return (
    <div>
      {label && <label className="text-sm font-medium text-charcoal-600 mb-1.5 block">{label}</label>}
      <input
        data-testid={testid}
        type={type}
        value={value ?? ""}
        placeholder={placeholder}
        onChange={(e) => onChange(type === "number" ? Number(e.target.value) : e.target.value)}
        className="w-full bg-white border border-sand-200 rounded-lg px-3 py-2 text-sm text-charcoal-800 focus:outline-none focus:ring-2 focus:ring-sage/50"
      />
    </div>
  );
}

export function Area({ label, value, onChange, testid, rows = 3 }) {
  return (
    <div>
      {label && <label className="text-sm font-medium text-charcoal-600 mb-1.5 block">{label}</label>}
      <textarea
        data-testid={testid}
        rows={rows}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-white border border-sand-200 rounded-lg px-3 py-2 text-sm text-charcoal-800 focus:outline-none focus:ring-2 focus:ring-sage/50"
      />
    </div>
  );
}

export function SaveButton({ onClick, saving, testid, children = "Save changes" }) {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      disabled={saving}
      className="rounded-full bg-terracotta px-6 py-2.5 text-sm text-white font-medium hover:bg-terracotta-hover transition-colors disabled:opacity-60"
    >
      {saving ? "Saving…" : children}
    </button>
  );
}

export function Card({ children, className = "", ...rest }) {
  return <div className={`rounded-xl bg-white p-6 shadow-sm border border-sand-200 ${className}`} {...rest}>{children}</div>;
}

export function SectionTitle({ title, subtitle }) {
  return (
    <div className="mb-6">
      <h1 className="font-serif text-2xl text-charcoal-800">{title}</h1>
      {subtitle && <p className="text-sm text-charcoal-500 mt-1">{subtitle}</p>}
    </div>
  );
}
